<template>
  <section class="section-two bg-light mt-5 mb-2">
    <div class="container-fluid">

      <div class="row justify-content-center">
        <div class="col-lg-10">
          <div class="row">
            <div class="col-8">
              <p class="h4">
                <b>Escolha o tipo de exame</b>
              </p>
            </div>
            <div class="col-4 mb-3 text-end">
              <button type="button" class="btn btn-outline-primary btn-sm"
                      @click="$router.back()">
                <i class="fa fa-arrow-left"></i> Voltar
              </button>
            </div>
          </div>

          <div class="card shadow rounded border-0 mb-3 pricing-rates business-rate"
               @click="selectExamType(type)"
               style="cursor: pointer;" v-for="type in types" :title="'Agendar exame ' + type.exam_type_name">
            <div class="m-3">
              <b class="h5 text-primary">{{type.exam_type_name}}</b>
              <i class="ms-1 fas fa-1x fa-arrow-circle-right text-primary"></i>
              <p class="text-muted mb-0">{{type.exam_type_description}}</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>
</template>

<script>
import http from "@/helpers/http";

export default {
  name: 'ExamType',
  data() {
    return {
      types: [],
    }
  },
  mounted() {
    this.getExamTypes();
  },
  methods: {
    getExamTypes() {
      http.get('/schedule/exams/types', {
        params: {
          id_city: this.$store.state.toSchedule.schedule.city?.id_city,
          id_place: this.$store.state.toSchedule.place?.id_place,
        }
      }).then((response) => {
        this.types = response.data;
      });
    },
    selectExamType(examType) {
      this.$store.commit('toSchedule/setAttendanceType', examType.exam_type);

      if (['EXAM', 'EXAM-DIAG', 'PROCEDURE'].includes(examType.exam_type)) {
        this.$router.push({
          path: '/specialty-groups',
          query: {
            mode: 'face-to-face',
            type: examType.exam_type.toLowerCase().includes('exam') ? 'exam' : examType.exam_type.toLowerCase(),
            id_exam_type: examType.id_exam_type
          }
        });
      } else {
        this.$router.push('/exams/payment-methods');
      }
    },
  }
}
</script>

<style scoped>

</style>
